import { render, staticRenderFns } from "./TransactionNotes.vue?vue&type=template&id=606fd0df&"
import script from "./TransactionNotes.vue?vue&type=script&lang=js&"
export * from "./TransactionNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports